import { getAppLocale, getAppLocaleAsObject } from '../app-locale';
import { appConfiguration } from '../app-starter';

const SR2SFT01 = 'SR2SFT01';

/**
* @param {string} template link
* @param {object} required values to be replaced in template
* @returns {string} string url
*/
function generateURLByTemplate(template, obj) {
  if (!obj || !Object.keys(obj).length) {
    throw new Error('Please provide required parameter.');
  }
  let finalLink = template;
  Object.keys(obj).forEach(prop => {
    if (obj[prop] && finalLink.includes(prop)) {
      finalLink = finalLink.replace(new RegExp(`{{${prop}}}`, 'g'), obj[prop]);
    }
  });
  return finalLink;
}

/**
* @param {string} template link
* @param {object} required values to be replaced in template
* @returns {string} string url
*/
function generateLinkByTemplate(template, obj) {
  if (!obj || !Object.keys(obj).length) {
    throw new Error('Please provide required parameter.');
  }
  let finalLink = template;
  Object.keys(obj).forEach(prop => {
    if (obj[prop] && finalLink.includes(prop)) {
      finalLink = finalLink.replace(new RegExp(`{${prop}}`, 'g'), obj[prop]);
    }
  });
  return finalLink;
}

export const buildReferenceLink = (ref, datasheetTemplate) => {
  const { lang, country } = getAppLocaleAsObject();
  const correctedCountry = (country === 'GB' ? 'UK' : country);

  if (datasheetTemplate) {
    const params = {
      productId: ref,
      'intl.countryCode': country.toLowerCase(),
      'intl.languageCode': lang
    };
    return generateURLByTemplate(datasheetTemplate, params);
  } else if (ref === SR2SFT01) {
    return `https://www.se.com/${correctedCountry.toLowerCase()}/${lang}/product-range-presentation/542-zelio-soft/`;
  }
  return `https://www.se.com/${correctedCountry.toLowerCase()}/${lang}/product/${ref}`;
}

export const buildDistributorPDFDownload = (ref) => {
  const { lang, country } = getAppLocaleAsObject();

  const correctedCountry = (country === 'GB' ? 'UK' : country);

  return `https://www.se.com/${correctedCountry.toLowerCase()}/${lang}/product/download-pdf/${ref}`;
}

export const buildDistributorPDFNewTab = (ref) => {
  const { lang, country } = getAppLocaleAsObject();

  const correctedCountry = (country === 'UK' ? 'GB' : country);

  return `https://download.schneider-electric.com/files?p_File_Name=${ref}_DATASHEET_${correctedCountry}_${lang}-${country}.pdf`;
}

export const buildMySchneiderUrl = () => {
  return `${process.env.REACT_APP_SEAMLESS_URL}?locale=${getAppLocale()}`;
}

export const buildMySchneiderRedirectionUrl = () => {
  let url = buildMySchneiderUrl();

  if (appConfiguration.startPageFilters?.references?.length > 0) {
    try {
      url += `&reference=${appConfiguration.startPageFilters.references.join(';')}`;
    } catch(e) {
      console.log('Error building MySchneider URL with references CBR');
    }
  }

  if (appConfiguration.startPageFilters?.ranges?.length > 0) {
    try {
      url += `&range_id=${appConfiguration.startPageFilters.ranges.join(';')}`;
    } catch(e) {
      console.log('Error building MySchneider URL with ranges CBR');
    }
  }

  if (appConfiguration.startPageFilters?.technologies?.length > 0) {
    try {
      url += `&technology=${appConfiguration.startPageFilters.technologies.join(';')}`;
    } catch(e) {
      console.log('Error building MySchneider URL with technologies CBR');
    }
  }

  if (appConfiguration.plcSearch) {
    url += `&plcSearch=${appConfiguration.plcSearch}`;
  }

  if (appConfiguration.searchType) {
    url += `&searchType=${appConfiguration.searchType}`;
  }

  if (appConfiguration.campaignId) {
    url += `&campaignId=${appConfiguration.campaignId}`;
  }

  return url;
}

export const buildMySchneiderUrlWithCBR = (cbrData, withSearch = false, ignoreParametersRedirection= false) => {
  let url = buildMySchneiderUrl();

  if (cbrData?.references && Object.keys(cbrData?.references).length > 0) {
    try {
      url += `&reference=${Object.keys(cbrData?.references).join(';')}`;
    } catch(e) {
      console.log('Error building MySchneider URL with references CBR');
    }
  }

  if (cbrData?.ranges && Object.keys(cbrData?.ranges).length > 0) {
    try {
      url += `&range_id=${Object.keys(cbrData?.ranges).join(';')}`;
    } catch(e) {
      console.log('Error building MySchneider URL with ranges CBR');
    }

  }

  if (cbrData?.technologies && Object.keys(cbrData?.technologies).length > 0) {
    try {
      url += `&technology=${Object.keys(cbrData?.technologies).join(';')}`;
    } catch(e) {
      console.log('Error building MySchneider URL with technologies CBR');
    }
  }

  if (withSearch && appConfiguration.plcSearch) {
    url += `&plcSearch=${appConfiguration.plcSearch}`;
  }

  if (withSearch && appConfiguration.searchType) {
    url += `&searchType=${appConfiguration.searchType}`;
  }

  if (ignoreParametersRedirection) {
    url += `&ignoreParametersRedirection=true`;
  }

  if (appConfiguration.campaignId) {
    url += `&campaignId=${appConfiguration.campaignId}`;
  }

  return url;
}

export const buildCustomerCenterUrl = () => {
  const { lang, country } = getAppLocaleAsObject();

  const correctedCountry = (country === 'GB' ? 'UK' : country);

  return `https://www.se.com/${correctedCountry.toLowerCase()}/${lang}/work/support/customer-care/contact-sales.jsp`;
}

export const buildSoftwareLink = (link) => {
  const { lang, country } = getAppLocaleAsObject();

  const correctedCountry = (country === 'GB' ? 'UK' : country);
  const params = {
    'country': correctedCountry.toLowerCase(),
    'language': lang
  }
  return generateLinkByTemplate(link, params);
}

